import { ValidationErrors, ValidatorFn } from '@angular/forms';
import { isPositiveNumber } from '@app/shared/utils/type-guards';
import { LdEventRepairStatus } from '@app/main/leak-detection/enums/ld-event-repair-status.enum';
import { IDialogEventDraft } from '@app/main/leak-detection/dialogs/dialog-event/interfaces/dialog-event-draft.interface';
import { needsAssignee } from '@app/main/leak-detection/dialogs/dialog-event/utils/dialog-event-draft';
import { isLeakFoundResult } from '@app/main/leak-detection/utils/ld-event-status';

export const dialogEventDraftValidator: ValidatorFn = (control): ValidationErrors | null => {
  const draft: IDialogEventDraft = control.getRawValue();

  const isLeak = isLeakFoundResult(draft.investigationResult);

  const rules: Record<string, boolean> = {
    assignee: needsAssignee(draft.status) && !draft.assignedTo,
    leakSize: isLeak && !isPositiveNumber(draft.leakSize),
    pressure: isLeak ? !isPositiveNumber(draft.pressure) : draft.pressure !== null && !isPositiveNumber(draft.pressure),
    soilComposition: isLeak && !draft.soilComposition,
    scheduledDate: isLeak && draft.repairStatus === LdEventRepairStatus.RepairScheduled && !draft.repairDate,
    repairDate: isLeak && draft.repairStatus === LdEventRepairStatus.Repaired && !draft.repairDate,
  };

  const broken = Object.entries(rules).filter(([, isBroken]) => isBroken);

  return broken.length ? Object.fromEntries(broken) : null;
};
